<template>
  <div id="app">
    <van-loading v-if="showLoading" />
    <!-- 绑定手机号弹窗 -->
    <BindPhoneDialog v-if="showBindPhone" />
    <!-- 绑定游戏账号弹窗 -->
    <BindGameAccountDialog v-if="showBindGameAccount" />
    <!-- 绑定账号新弹窗 支持账号密码和手机验证码 -->
    <BindAccountDialog
      ref="bindAccountRef"
      @close="onCloseBindAccountDialog"
    />
    <!-- 注册弹窗 -->
    <RegisterDialog v-if="showRegisterDialog" />
    <!-- 帖子编辑区域 -->
    <IssueTopicField v-if="showTopicField" @closeIssueTopicField="closeIssueTopicField" />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive" />
    <BottomNavigation
      v-if="$route.meta.bottomNav"
      :currentPath="$route.path"
      @showTopicField="openIssueTopicField"
    />
    <!-- 分享遮罩层 -->
    <van-overlay v-show="showShareMask" z-index="202" @click="closeShareMask">
      <div :class="$style['show-share-mask']">
        <div :class="$style['share-text']">
          点击右上角按钮
          <br />选择“分享到朋友圈”
        </div>
      </div>
    </van-overlay>
    <SuspendBall v-if="suspendShow" ref="suspendBall"/>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import BindPhoneDialog from '@/components/CustomDialogs/BindPhoneDialog';
import BindGameAccountDialog from '@/components/CustomDialogs/BindGameAccountDialog';
import IssueTopicField from '_c/IssueTopicField';
import BottomNavigation from '_c/BottomNavigation';
import RegisterDialog from '_c/RegisterDialog';
import { Dialog, Loading, Overlay } from 'vant';
import BindAccountDialog from '@/components/CustomDialogs/BindAccountDialog.vue';
import SuspendBall from '@/components/SuspendBall/index.vue';
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  components: {
    BindPhoneDialog,
    BindGameAccountDialog,
    BindAccountDialog,
    IssueTopicField,
    BottomNavigation,
    RegisterDialog,
    VanLoading: Loading,
    VanOverlay: Overlay,
    SuspendBall
  },
  data() {
    return {
      isRouterAlive: true,
      showTopicField: false,
    };
  },
  computed: {
    ...mapState('app', {
      showLoading: (state) => state.showLoading,
      showShareMask: (state) => state.showShareMask,
      showBindPhone: (state) => state.showBindPhone,
      showBindGameAccount: (state) => state.showBindGameAccount,
      showRegisterDialog: (state) => state.showRegisterDialog,
      showBindAccountDialog: (state) => state.showBindAccountDialog,
    }),
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false;
      return flag;
    },
    suspendShow() {
      return this.$route.meta.suspend;
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name) {
        this.reload();
      } else {
        this.onCloseBindAccountDialog();
      }

      if (to.meta.suspend) {
        this.$nextTick(() => {
          this.$refs.suspendBall.getFloatBallInfo();
        });
      }
    },
    showBindAccountDialog (value) {
      this.$refs.bindAccountRef.triggerVisible(value);
    },
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHARE_MASK: 'CHANGE_SHARE_MASK',
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG',
      CHANGE_BIND_ACCOUNT_DIALOG: 'CHANGE_BIND_ACCOUNT_DIALOG',
    }),
    onCloseBindAccountDialog () {
      this.CHANGE_BIND_ACCOUNT_DIALOG(false);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    closeShareMask() {
      this.CHANGE_SHARE_MASK(false);
    },
    openIssueTopicField() {
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true);
        return;
      }
      this.showTopicField = true;
    },
    closeIssueTopicField() {
      this.showTopicField = false;
    },
  },
};
</script>
<style lang="scss" module>
@import '~@/styles/_variable.scss';
#app {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.loading {
  position: absolute;
  z-index: 99999;
  top: 40%;
  left: 45%;
}
.show-share-mask {
  position: absolute;
  z-index: 110;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  .share-text {
    position: absolute;
    top: 26%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 300px;
    font-size: 26px;
    line-height: 36px;
    text-align: center;
    color: #c9c9c9;
  }
  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    right: 15px;
    background-image: url('#{$cdn-url-hm}/hero/arrows.png');
    background-size: cover;
    width: 80px;
    height: 115px;
  }
  &::before {
    content: ' ';
    position: absolute;
    bottom: 10%;
    background-image: url('#{$cdn-url-hm}/vote_activity/share3.png');
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 320px;
  }
}
</style>
